/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentChildren } from 'preact';
import { CollectionGestureContext } from '../hooks/PRIVATE_useCollectionGestureContext';
import { classNames } from '../utils/UNSAFE_classNames';
import { preventDefaultForCurrentTarget } from './eventUtils';
import { dropdownStyles } from './themes/dropdownStyles.css';

type Props = {
  children?: ComponentChildren;
  hasTopGap?: boolean;
  hasBottomGap?: boolean;
  isLoading?: boolean;
};

export function DropdownList({
  children,
  hasTopGap = true,
  hasBottomGap = true,
  isLoading = false
}: Props) {
  const styleClasses = classNames([
    dropdownStyles.list.base,
    hasTopGap && dropdownStyles.list.topGap,
    hasBottomGap && dropdownStyles.list.bottomGap,
    isLoading && dropdownStyles.list.loading
  ]);
  return (
    <CollectionGestureContext.Provider value={'embedded'}>
      <div class={styleClasses} onMouseDown={preventDefaultForCurrentTarget}>
        {children}
      </div>
    </CollectionGestureContext.Provider>
  );
}
